document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll('.swiper.collection-swiper');

  sliders.forEach(slider => {
    const id = slider.dataset.id;

    // Get the height of the .collection-swiper-img element for the specific slider
    const imgHeight = slider.querySelector('.collection-swiper-img').offsetHeight;
    const buttonTopPosition = (imgHeight / 2) + "px";

    // Adjust the top position for the specific slider's buttons
    slider.querySelector(`.swiper-button-prev[data-id="${id}"]`).style.top = buttonTopPosition;
    slider.querySelector(`.swiper-button-next[data-id="${id}"]`).style.top = buttonTopPosition;

    const swiper = new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        nextEl: `.swiper-button-next[data-id="${id}"]`,
        prevEl: `.swiper-button-prev[data-id="${id}"]`,
      },
      breakpoints: {
        750: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 6,
          spaceBetween: 24,
        },
      }
    });

    // Listen for Swiper's own resize event
    swiper.on('resize', adjustButtonPosition);
  });

  function adjustButtonPosition() {
    sliders.forEach(slider => {
      const id = slider.dataset.id;

      const imgHeight = slider.querySelector('.collection-swiper-img').offsetHeight;
      const buttonTopPosition = (imgHeight / 2) + "px";

      slider.querySelector(`.swiper-button-prev[data-id="${id}"]`).style.top = buttonTopPosition;
      slider.querySelector(`.swiper-button-next[data-id="${id}"]`).style.top = buttonTopPosition;
    });
  }

  adjustButtonPosition(); // Initial adjustment
});
